export enum EnumPaymentType {
    Yookassa = 'yookassa',
    YookassaSBP = 'yookassa-sbp',
    Invoice = 'invoice',
    Prodamus = 'prodamus'
    
}

export function isValidEnumPaymentType(value:string){
    return (Object as any).values(EnumPaymentType).includes(value)
}

export function getRussianTextForEnumPaymentType(value?:EnumPaymentType){
    switch(value){
        case EnumPaymentType.Invoice: return 'Выставите мне счет'
        case EnumPaymentType.Yookassa: return 'Оплата онлайн по карте'
        case EnumPaymentType.YookassaSBP: return 'Оплата по Системе Быстрых Платежей (СБП)'
        case EnumPaymentType.Prodamus: return 'Оплата онлайн по карте'
        default: return 'Неизвестно'
    }
}